<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (isSearching) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

<p-table #pt [value]="reservations" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="reservationId" selectionMode="single"
  [(selection)]="reservation" (onRowSelect)="onRowSelect($event)" [loading]="false" [paginator]="showPagination" [rows]="250" [rowsPerPageOptions]="[250,500,1000, 2000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      @if (!titleFontSize) {
        <h1 style="float: left;margin: 6px;">Reservations</h1>
      }
      @if (titleFontSize) {
        <h4 style="float: left;margin: 6px;">Reservations</h4>
      }
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <!-- Sync all reservation on main menu -->
        @if (!propertyId) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="syncAllReservationsConfirmation()">Sync All Reservations</button>
        }

        <!-- Sync reservation by property on edit property window -->
        @if (propertyId) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="syncReservationsByPropertyConfirmation()">Sync Reservations By Property</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
    </tr>
    @if (showFilter) {
      <tr>
        <th>
          <p-multiSelect [options]="constantService.reservationWikiStatuses" defaultLabel="Status"
          (onChange)="pt.filter($event.value, 'reservationStatus', 'in')" appendTo="body"></p-multiSelect>
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'PropertyVO.propertyCode', 'in')">
        </th>
        <!-- <th [ngStyle]="{'width': 'auto'}"></th> -->
        <th>
          <input pInputText style="width:150px;" type="text"
            (input)="pt.filter($event.target.value, 'lastname', 'startsWith')">
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
        (input)="pt.filter($event.target.value, 'checkInDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
        (input)="pt.filter($event.target.value, 'checkOutDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th>
          <input pInputText style="width:150px;" type="text"
            (input)="pt.filter($event.target.value, 'reservationId', 'in')">
        </th>
        <th>
          <input pInputText style="width:150px;" type="text"
            (input)="pt.filter($event.target.value, 'extReservationId', 'in')">
        </th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-reservation>
    <tr [pSelectableRow]="reservation">
      <td [style.background-color]="getResStatusColor(reservation?.reservationStatus, reservation?.reservationType)">
      {{getResStatusName(reservation?.reservationStatus, reservation?.reservationType)}}</td>
      <!-- <td>{{reservation?.createDate|date:'MM/dd/yy'}}</td> -->
      <td><b>{{reservation?.propertyCode}}</b></td>
      <td><b>{{reservation?.lastname}}</b></td>
      <td style="white-space: nowrap;">{{reservation?.checkInDate|date:'MM/dd/yy EEEEEE'}}</td>
      <td style="white-space: nowrap;">{{reservation?.checkOutDate|date:'MM/dd/yy EEEEEE'}}</td>
      <td style="text-align: center;">{{reservation?.numNights}}</td>
      <td>{{reservation?.numAdults}}/{{reservation?.numChildren}} {{reservation?.numPets}}</td>
      <td>{{reservation?.roomRatePN|currency}}</td>
      <td>{{reservation?.reservationId}}</td>
      <td>{{reservation?.extReservationId}}</td>
    </tr>
  </ng-template>
</p-table>